<div class="join-container">
  <div class="join-card">

    @if (!isExpired) {
      <div class="join-icon">
        <mat-icon>video_call</mat-icon>
      </div>
      <h2 class="join-title">Joining your session</h2>
      <p class="join-subtitle">
        Hang tight — we're registering your attendance and opening the meeting link.
      </p>
      <div class="dots">
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
      </div>
      <p class="join-hint">The meeting will open in a new tab</p>
    }

    @if (isExpired) {
      <div class="join-icon expired">
        <mat-icon>link_off</mat-icon>
      </div>
      <h2 class="join-title">This link has expired</h2>
      <p class="join-subtitle">
        This meeting link is no longer valid.
      </p>
      <button mat-stroked-button (click)="this.router.navigate(['/portal/home'])">
        Go to home
      </button>
    }

  </div>
</div>